var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.33 12.9961C44.825 11.0297 43.3325 9.48129 41.44 8.95484C38.01 8 24.25 8 24.25 8C24.25 8 10.49 8 7.06 8.95484C5.1675 9.48129 3.675 11.0297 3.17 12.9961C2.25 16.5626 2.25 24 2.25 24C2.25 24 2.25 31.4374 3.17 35.0039C3.675 36.9703 5.1675 38.5187 7.06 39.0452C10.49 40 24.25 40 24.25 40C24.25 40 38.01 40 41.44 39.0452C43.3325 38.5187 44.825 36.9703 45.33 35.0039C46.25 31.4374 46.25 24 46.25 24C46.25 24 46.25 16.5626 45.33 12.9961ZM19.75 30.7535V17.2465L31.25 24L19.75 30.7535Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.61e790b7bb5b028459e88bdbc3c5bd4b.svg";
export { ForwardRef as ReactComponent };